<form [formGroup]="userProfileForm">
  <div>
    <span class="section-heading">Projects</span>

    <div class="fresh">
      <i class="bi bi-lightbulb"></i>
      For Freshers: Projects are your strongest section. Add 2-3 meaningful
      projects with clear outcomes and tools used.
    </div>
  </div>

  <div formArrayName="projects">
    <div
      *ngFor="let project of projects.controls; let i = index"
      [formGroupName]="i"
      class="form-card mb-3"
    >
      <span (click)="removeProject(i)" *ngIf="projects.length > 1">
        <i class="bi bi-trash-fill remove"></i>
      </span>

      <h3 class="section-title">
        <i class="bi bi-kanban-fill"></i>
        Project {{ i + 1 }}
      </h3>

      <div class="form-group">
        <label>Project Title <span> *</span></label>
        <input
          type="text"
          formControlName="title"
          placeholder="e.g. E-commerce Website"
        />

        <small class="text-danger smaller-text"
            *ngIf="(getControl(i, 'title')?.touched || getControl(i, 'title')?.dirty)
            && getControl(i, 'title')?.errors?.['required']">
            Project title is required
          </small>
      </div>

      <div class="form-group full">
        <label>Description <span> *</span></label>

        <textarea
          formControlName="description"
          rows="4"
          placeholder="Describe what you built, your role, and key features..."
        >
        </textarea>

        <ng-container *hasPermission="PermissionForStudents.RESUME_SUGGEST">
       <button type="button"
        class="ai-btn"
        (click)="postAiDescription(i)"
        [disabled]="aiLoadingIndex === i">
        <i class="bi"
         [ngClass]="aiLoadingIndex === i ? 'bi-arrow-repeat spin' : 'bi-stars'"></i>
       <span> {{ aiLoadingIndex === i ? 'Improving...' : 'Improve with AI' }} </span>
       </button>
       </ng-container>

        <small class="text-danger smaller-text"
          *ngIf="(getControl(i, 'description')?.touched || getControl(i, 'description')?.dirty)
          && getControl(i, 'description')?.errors?.['required']">
          Description is required
        </small>

        
      </div>

      <div class="form-grid">
        <div class="form-group">
          <label>Tools / Technologies</label>
          <input
            type="text"
            formControlName="technologies"
            placeholder="e.g. Angular, Node.js, MySQL"
          />
        </div>

        <div class="form-group">
          <label>Outcome / Impact</label>
          <input
            type="text"
            formControlName="outcome"
            placeholder="e.g. Improved performance by 40%"
          />
        </div>
      </div>
    </div>
  </div>

  <button type="button" class="add-btn" (click)="addProject()">
    + Add Another Project
  </button>
</form>
